export default {
  oversizedWarning: 'This workbook is oversized, degrading performance. Please reduce the size of the source file.',
  syncUserDeleteWarning: 'The user that initiated the synchronization of the workbook is no longer active, please reinitiate with another user.'
};